export default "__VITE_ASSET__QlgE1v0G__"